export default "__VITE_ASSET__Dy8_BKJF__"